import React, { useEffect, useState, useCallback } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";

import Swal from "sweetalert2";
import Select from "react-select";
import Flatpickr from "react-flatpickr";

const MoveStudentModal = ({ show, studentId, onClose, onSuccess }) => {

  const token = localStorage.getItem("authToken");
  const user = JSON.parse(localStorage.getItem("authUser"));
  const [loading, setLoading] = useState(false);

  const [studentName, setStudentName] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedSecondDay, setSelectedSecondDay] = useState("");
  const [selectedSecondTime, setSelectedSecondTime] = useState("");
  const [selectedLessonPlan, setSelectedLessonPlan] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [classId, setClassId] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);

  const [dayError, setDayError] = useState("");
  const [timeError, setTimeError] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");
  const [secondDayError, setSecondDayError] = useState("");
  const [secondTimeError, setSecondTimeError] = useState("");

  const mysqlToDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";

    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const loadDetails = useCallback(async () => {
    if (!studentId) return;
    try {
      setLoading(true);
      const res = await fetch(
        `https://api.kunalsdrumclass.com/api/GetStudentById?id=${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const json = await res.json();
      const item = json?.recordsets?.[0]?.[0];
      const item1 = json?.recordsets?.[1]?.[0];
      const item2 = json?.recordsets?.[1]?.[1];

      setStudentName(item.Student_Name);
      setClassId(item.Student_Class_Id);
      setSelectedLessonPlan(item.Lesson_Plan);
      setSelectedDay(item1.Day_Of_Week);
      setSelectedTime(item1.Time);
      setStartDate(mysqlToDDMMYYYY(item.Start_Date));
      setEndDate(mysqlToDDMMYYYY(item.End_Date));

      if (item.Lesson_Plan === "Twice a week") {
        setSelectedSecondDay(item2.Day_Of_Week);
        setSelectedSecondTime(item2.Time);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [studentId]);

  useEffect(() => {
    if (show) {
      loadDetails();
    }
  }, [show, loadDetails]);

  useEffect(() => {
    if (!selectedDay) return;
    const fetchSlots = async () => {
      try {
        const res = await fetch(`https://api.kunalsdrumclass.com/api/GetBatchSlotsByDay?day=${selectedDay}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const json = await res.json();
        setTimeSlots(json?.recordsets?.[0] || []);
      } catch (error) {
        console.error(error);
      }
    };

    fetchSlots();
  }, [selectedDay]);

  const slotOptions = timeSlots.map(item => ({
    value: item.Batch_Time,
    label: item.Batch_Time,
    availableSlots: item.Available_Slots,
    isDisabled: item.Available_Slots === 0
  }));

  const dayOptions = [
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" }
  ];

  const handleSave = async () => {
    setDayError("");
    setTimeError("");
    setStartDateError("");
    setEndDateError("");
    setSecondDayError("");
    setSecondTimeError("");

    let hasError = false;

    if (!selectedDay) {
      setDayError("Day is required");
      hasError = true;
    }

    if (!selectedTime) {
      setTimeError("Time is required");
      hasError = true;
    }

    if (!startDate) {
      setStartDateError("Start Date is required");
      hasError = true;
    }

    if (!endDate) {
      setEndDateError("End Date is required");
      hasError = true;
    }

    if (selectedLessonPlan === "Twice a week") {
      if (!selectedSecondDay) {
        setSecondDayError("Second Day is required");
        hasError = true;
      }

      if (!selectedSecondTime) {
        setSecondTimeError("Second Time is required");
        hasError = true;
      }
    }

    if (hasError) return;

    try {
      setLoading(true);

      const [d, m, y] = startDate.split("-");
      const [dd, mm, yy] = endDate.split("-");
      const mysqlDate1 = `${y}-${m}-${d}`;
      const mysqlDate2 = `${yy}-${mm}-${dd}`;

      const payload1 = {
        studentClassId: classId,
        dayOfWeek: selectedDay,
        time: selectedTime,
        startDate: mysqlDate1,
        endDate: mysqlDate2,
        createdBy: user.Id
      };

      await fetch(`https://api.kunalsdrumclass.com/api/MoveStudentClassSchedule`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload1),
        }
      );

      if (selectedLessonPlan === "Twice a week") {

        const payload2 = {
          studentClassId: classId,
          dayOfWeek: selectedSecondDay,
          time: selectedSecondTime,
          startDate: mysqlDate1,
          endDate: mysqlDate2,
          createdBy: user.Id
        };

        await fetch(`https://api.kunalsdrumclass.com/api/MoveStudentClassSchedule`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload2),
          }
        );
      }

      await Swal.fire({
        title: "Success!",
        text: `student moved successfully!`,
        icon: "success",
        customClass: {
          popup: "swal2-material-ui",
          confirmButton: "btn btn-sm rounded-8 btn-primary",
        },
      });

      onSuccess();
      onClose();

    } catch (error) {
      console.error(error);
      await Swal.fire({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        confirmButtonColor: "#d32f2f",
        customClass: {
          popup: "swal2-material-ui",
          confirmButton: "error-alert",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={show} toggle={onClose} backdrop="static" keyboard={false}>
      <ModalHeader toggle={onClose}>
        Move Student
      </ModalHeader>

      <ModalBody>
        {loading ? (
          <div className="text-center">
            <Spinner />
          </div>
        ) : (
          <div className="row">
            <div className="col-lg-12 mb-3">
              <label>Student Name*</label>
              <input
                className="form-control"
                value={studentName}
                disabled
              />
            </div>
            <div className="col-lg-6 mb-3">
              <label>Day*</label>
              <Select
                value={
                  dayOptions.find(
                    option => option.value === selectedDay
                  ) || null
                }
                onChange={(selectedOption) =>
                  setSelectedDay(
                    selectedOption ? selectedOption.value : ""
                  )
                }
                options={dayOptions}
                isClearable
                classNamePrefix="select2-selection"
                placeholder="Select Day"
              />
              {dayError && (
                <div className="text-danger mt-1">
                  {dayError}
                </div>
              )}
            </div>
            <div className="col-lg-6 mb-3">
              <label>Time*</label>
              <Select
                value={
                  slotOptions.find(
                    option => option.value === selectedTime
                  ) || null
                }
                onChange={(selectedOption) =>
                  setSelectedTime(
                    selectedOption ? selectedOption.value : ""
                  )
                }
                options={slotOptions}
                isClearable
                classNamePrefix="select2-selection"
                placeholder="Select Time"
                formatOptionLabel={(option, { context }) =>
                  context === "menu" ? (
                    option.availableSlots === 0
                      ? `${option.label} (Full)`
                      : `${option.label} (${option.availableSlots} slots left)`
                  ) : (
                    option.label
                  )
                }
              />
              {timeError && (
                <div className="text-danger mt-1">
                  {timeError}
                </div>
              )}
            </div>

            {selectedLessonPlan === "Twice a week" && (
              <>
                <div className="col-lg-6 mb-3">
                  <label>Second Day*</label>
                  <Select
                    value={
                      dayOptions.find(
                        option => option.value === selectedSecondDay
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      setSelectedSecondDay(
                        selectedOption ? selectedOption.value : ""
                      )
                    }
                    options={dayOptions}
                    isClearable
                    classNamePrefix="select2-selection"
                    placeholder="Select Second Day"
                  />
                  {secondDayError && (
                    <div className="text-danger mt-1">
                      {secondDayError}
                    </div>
                  )}
                </div>
                <div className="col-lg-6 mb-3">
                  <label>Second Time*</label>
                  <Select
                    value={
                      slotOptions.find(
                        option => option.value === selectedSecondTime
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      setSelectedSecondTime(
                        selectedOption ? selectedOption.value : ""
                      )
                    }
                    options={slotOptions}
                    isClearable
                    classNamePrefix="select2-selection"
                    placeholder="Select Second Time"
                    formatOptionLabel={(option, { context }) =>
                      context === "menu" ? (
                        option.availableSlots === 0
                          ? `${option.label} (Full)`
                          : `${option.label} (${option.availableSlots} slots left)`
                      ) : (
                        option.label
                      )
                    }
                  />
                  {secondTimeError && (
                    <div className="text-danger mt-1">
                      {secondTimeError}
                    </div>
                  )}
                </div>
              </>
            )}

            <div className="col-lg-6 mb-3">
              <label>Start Date*</label>
              <div className="input-group">
                <Flatpickr
                  className="form-control"
                  value={startDate}
                  options={{
                    dateFormat: "d-m-Y",
                    minDate: startDate ? startDate : "today"
                  }}
                  onChange={(selectedDates, dateStr) => {
                    setStartDate(dateStr);
                  }}
                />
                {startDateError && (
                  <div className="text-danger mt-1">
                    {startDateError}
                  </div>
                )}
                <div className="input-group-append">
                  <span className="input-group-text">
                    <i className="mdi mdi-calendar" />
                  </span>
                </div>
              </div>
            </div>

            <div className="col-lg-6 mb-3">
              <label>End Date*</label>
              <div className="input-group">
                <Flatpickr
                  className="form-control"
                  value={endDate}
                  options={{
                    dateFormat: "d-m-Y",
                    minDate: startDate ? startDate : "today"
                  }}
                  onChange={(selectedDates, dateStr) => {
                    setEndDate(dateStr);
                  }}
                />
                {endDateError && (
                  <div className="text-danger mt-1">
                    {endDateError}
                  </div>
                )}
                <div className="input-group-append">
                  <span className="input-group-text">
                    <i className="mdi mdi-calendar" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <Button
          color="secondary"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleSave}
          disabled={loading}
        >
          Update
        </Button>
      </ModalFooter>
    </Modal>
  );

};

export default MoveStudentModal;